import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
// Auth removed: no Google OAuth provider
import "bootstrap/dist/css/bootstrap.min.css";

import theme from "./theme/muiTheme";
import { PatternProvider } from "./contexts/PatternContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import "./loops-purls-theme.css";

// Pages
import Welcome from "./pages/Welcome";
import AboutPage from "./pages/AboutPage";
import GuidesPage from "./pages/GuidesPage";
import ChartMaker from "./pages/ChartMaker";
import Gallery from "./pages/Gallery";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

// Layout
import Navigation from "./components/layout/Navigation";
import Footer from "./components/layout/Footer";
import LoadingOverlay from "./components/common/LoadingOverlay";
import AppWithLoading from "./components/common/AppWithLoading";

function App() {
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PatternProvider>
        <LoadingProvider>
          <AppWithLoading>
            <Router>
              <div className="App">
                <Navigation />
                <Routes>
                  <Route path="/" element={<Welcome />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/guides" element={<GuidesPage />} />
                  <Route path="/chart-maker" element={<ChartMaker />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                </Routes>
                <Footer />
                <LoadingOverlay />
              </div>
            </Router>
          </AppWithLoading>
        </LoadingProvider>
      </PatternProvider>
    </ThemeProvider>
  );
}

export default App;
